import React, { Fragment } from "react";
import { reduxForm } from "redux-form";
import Typography from "@material-ui/core/Typography";
import { Link } from "react-router-dom";

const WizardFormErrorPage = props => {
  return (
    <Fragment>
      <Typography variant="title" color="inherit">
        Submission Error
      </Typography>
      <hr />
      <div className="alert alert-danger" role="alert">
        {" "}
        <p>Their was an error submitting your sample Please try again later</p>
      </div>

      <Link className="btn btn-danger btn-lg" to="/" role="button">
        Exit
      </Link>
    </Fragment>
  );
};

export default reduxForm({
  form: "wizard", //Form name is same
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true // <------ unregister fields on unmount
})(WizardFormErrorPage);



// WEBPACK FOOTER //
// ./src/components/wizardSection/WizardFormErrorPage.jsx